import ky from 'ky'
import { httpError } from '../utils/errors'

/**
 * AuthService provides user authentication API services
 */
class AuthService {

    signInWithEmailAndPassword = (email, password, willRemember, auth) => {
        // Sign in somehow - simulate with a delay now
        return new Promise((resolve, reject) => {

            const formData = new FormData();
            formData.append('username', email);
            formData.append('password', password);
            formData.append('remember', willRemember ? 'true' : 'false');
            formData.append('auth', auth ? auth : 'pw');
            formData.append('property', 'phonethru');

            // Post the formData to the login endpoint.
            ky.post('/api/v2/auth/login', { body: formData }).json()
                .then(result => resolve(result))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    /**
     * whoAmI returns data about the logged in user.
     *
     * @returns {Promise<unknown>}
     */
    whoAmI = () => {

        return new Promise((resolve, reject) => {
            // hit the 'whoami' endpoint to see if we have a login cookie.
            ky.get('/api/v2/auth/whoami').json()
                .then( data => {
                    resolve(data);
                })
                .catch(error => {
                    if (error instanceof ky.HTTPError) {
                        // We got a response from the server

                        // 401 errors mean we're not authenticated which is what we're
                        // trying to determine so it's not actually an error for our purposes
                        if (error.response.status === 401) {
                            resolve(null)
                            return
                        }

                        // At this point the server response is an actual error...
                        // Read the body to see if the server returned anything
                        error.response.text().then(body => {
                            // Convert the body to json.  If it fails, fall back to the string
                            let data;
                            try {
                                data = JSON.parse(body)
                            } catch {
                                data = body;
                            }
                            //console.log('promise', body)
                            reject({
                                status: error.response.status,
                                statusText: error.response.statusText,
                                data
                            })
                        })

                    } else if (error instanceof ky.TimeoutError) {
                        // We timed out
                        reject({status: 0, statusText: 'The request timed out', data: null})
                    } else {
                        // It's a low level error. Networking issue?
                        //console.log('error looks to be terminal')
                        reject({status: 0, statusText: 'Check your internet connection', data: null})
                    }
                })
        })

    }

    /**
     * Log out the current user
     * @returns {Promise<unknown>}
     */
    logout = () => {
        // Perform the logout
        return new Promise( (resolve, reject) => {
            //console.log('logging out')
            ky.post('/api/v2/auth/logout')
                .then(() => resolve())
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    requestPasswordReset = (email) => {
        //console.log('AccountService.requestPasswordReset', email);
        return new Promise((resolve, reject) => {
            ky.post('/api/v2/auth/reset', {json: {email}})
                .then(() => resolve())
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    resetPassword = (obj) => {
        //console.log('AccountService.resetPassword', obj);
        return new Promise((resolve, reject) => {
            ky.post('/api/v2/auth/reset', {json: obj})
                .then(() => resolve())
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

    requestOTP = (username) => {
        // Request a one-time password
        //console.log('AccountService.requestOTP', username);
        return new Promise((resolve, reject) => {
            ky.post('/api/v2/auth/otp', {json: {username}}).json()
                .then(response => resolve(response))
                .catch(error => httpError(error).then(er => reject(er)))
        })
    }

}

// Create a singleton instance of the service to export
const instance = new AuthService();

export default instance;